/**
 * Created by methee on 9/5/17.
 */
import React from 'react';
import { defineMessages } from 'react-intl';

import Layout from '../../components/Layout';
import Conditions from './Conditions';

const messages = defineMessages({
  title: {
    id: 'title.conditions',
    defaultMessage: '##Terms and Conditions##',
    description: 'Terms and Conditions page titles',
  },
});

async function action({ intl, fetch, cdnUrl, locale }) {
  let environment = 'production';
  // if (
  //   process.env.BROWSER &&
  //   (window.App.env === 'develop' || window.App.env === 'staging')
  // ) {
  //   environment = 'staging';
  // }
  if (process.env.ENV !== 'production') {
    environment = 'staging';
  }
  const title = intl.formatMessage(messages.title);
  const respEn = await fetch(`${cdnUrl}legal/${environment}/en.json`);
  const legalEn = await respEn.json();
  const resp = await fetch(`${cdnUrl}legal/${environment}/${locale}.json`);
  const legal = await resp.json();
  const conditions = { ...legalEn.conditions, ...legal.conditions };
  const hotels = { ...legalEn.hotel, ...legal.hotel };
  return {
    chunks: ['conditions'],
    title,
    component: (
      <Layout>
        <Conditions conditions={conditions} hotels={hotels} />
      </Layout>
    ),
  };
}

export default action;
